import React, { useMemo } from "react";
import { Link } from "gatsby";
import classNames from "classnames";

import styles from "./Header.module.scss";
import { MenuIcon } from "../../common/MenuIcon";
import { Expandable } from "../../common/Expandable";
import { Nav } from "../Nav";

interface HeaderProps {
  navOpen: boolean;
  setNavOpen: (open: boolean) => void;
  display?: boolean;
}

const Header: React.FC<HeaderProps> = ({ navOpen, setNavOpen, display }) => {
  const cls = classNames(styles.header, { [styles.display]: display });

  const logoLetters = useMemo(() => {
    return "Creativé Elеphаnṭ".split("");
  }, []);

  return (
    <>
      <header className={cls}>
        <div className={styles.top}>
          <div className={styles.logo}>
            <Link to="/map">
              <h1>
                {logoLetters.map((l, idx) => (
                  <span key={idx}>{l}</span>
                ))}
              </h1>
            </Link>
          </div>
          <div className={styles.tagline}>
            <Link to="/">
              Celebrating the arts & creativity in this diverse Southwark &
              Lambeth community
            </Link>
          </div>
          <MenuIcon
            className={styles.menuBtn}
            open={navOpen}
            onClick={() => setNavOpen(!navOpen)}
          />
        </div>

        <div className={styles.bottom}>
          <Expandable open={navOpen}>
            <Nav />
          </Expandable>
        </div>
      </header>
      <div
        role="button"
        onClick={() => setNavOpen(false)}
        className={classNames(styles.overlay, { [styles.open]: navOpen })}
      />
    </>
  );
};

export { Header };
